import { render, staticRenderFns } from "./SupporterDonations.vue?vue&type=template&id=3d51860a&scoped=true&"
import script from "./SupporterDonations.vue?vue&type=script&lang=js&"
export * from "./SupporterDonations.vue?vue&type=script&lang=js&"
import style0 from "./SupporterDonations.vue?vue&type=style&index=0&id=3d51860a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d51860a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d51860a')) {
      api.createRecord('3d51860a', component.options)
    } else {
      api.reload('3d51860a', component.options)
    }
    module.hot.accept("./SupporterDonations.vue?vue&type=template&id=3d51860a&scoped=true&", function () {
      api.rerender('3d51860a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/supporters/views/Donations/SupporterDonations.vue"
export default component.exports